export function useSearchParams(param) {
    function serializeObject(): string {
        return JSON.stringify(param)
    }

    function deserializeObjectToArr() {
        return [].concat(param).map((item) => JSON.parse(item))
    }

    return { serializeObject, deserializeObjectToArr }
}
